var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "list-style-type": "none" } },
    [
      _c(
        "b-dropdown-item",
        {
          attrs: { href: "#" },
          on: {
            click: function($event) {
              return _vm.confirmAction("pivot")
            }
          }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "19",
                height: "19",
                viewBox: "0 0 24 24"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2m0 12v-5m3 5v-1m3 1v-3"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" Exibir Relatório")
        ]
      ),
      _vm._v(" "),
      _c("dashboard-menu", {
        attrs: {
          onlyDash: false,
          hasIcon: false,
          requestId: this.feature.sourceLayer
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }